<template>
  <span
    style="display: inline-block; cursor: pointer;"
    @click="$emit('click')"
  >

    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.6979 8L14 12.3021L12.3021 14L8 9.6979L3.6979 14L2 12.3021L6.3021 8L2 3.6979L3.6979 2L8 6.3021L12.3021 2L14 3.6979L9.6979 8Z"
        fill="black"
        fill-opacity="0.5"
      />
    </svg>
  </span>
</template>

<script>
export default {
  name: 'CloseIconThick',
}
</script>
